const clamp = (value: number, min: number, max: number) =>
    Math.max(min, Math.min(max, value));

type HorizontalGradientBarProps = {
    value: number;
    min: number;
    max: number;
    gradient: string;
};

export const HorizontalGradientBar = ({
    value,
    min,
    max,
    gradient,
}: HorizontalGradientBarProps) => {
    const pct = ((clamp(value, min, max) - min) / (max - min)) * 100;
    return (
        <div className="relative w-full h-4 flex items-center">
            <div
                className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-1.5 rounded-full"
                style={{ backgroundImage: gradient }}
            />
            <div
                className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-4 w-0.75 rounded-sm bg-white shadow-[0_0_4px_rgba(0,0,0,0.6)]"
                style={{ left: `${pct}%` }}
            />
        </div>
    );
};
